import {useSelector} from "react-redux";

export default function () {
    const proactive = useSelector(state => state.proactive);
    const loadingUpdateSuggestedResponse = proactive.loadingUpdateSuggestedResponse;
    const suggestedResponse = proactive.updateSuggestedResponse;
    const updatingResponseId = proactive.updatingResponseId;
    return { suggestedResponse, loadingUpdateSuggestedResponse, updatingResponseId };
}